import useCompany from '@/compositions/useCompany';
import { computed } from '@vue/composition-api';

export default function usePermissions() {
  const { company } = useCompany();

  return {
    canStoreVacancies: computed(() => company.value.permissions.vacancyStore),
  };
}
